module.exports = __webpack_public_path__ + "img/TC.24a78938.png";